/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdatePalReauthDocumentSelections200ResponseData } from './UpdatePalReauthDocumentSelections200ResponseData';
import {
    UpdatePalReauthDocumentSelections200ResponseDataFromJSON,
    UpdatePalReauthDocumentSelections200ResponseDataFromJSONTyped,
    UpdatePalReauthDocumentSelections200ResponseDataToJSON,
    UpdatePalReauthDocumentSelections200ResponseDataToJSONTyped,
} from './UpdatePalReauthDocumentSelections200ResponseData';

/**
 * 
 * @export
 * @interface UpdatePalReauthDocumentSelections200Response
 */
export interface UpdatePalReauthDocumentSelections200Response {
    /**
     * 
     */
    data?: UpdatePalReauthDocumentSelections200ResponseData;
}

/**
 * Check if a given object implements the UpdatePalReauthDocumentSelections200Response interface.
 */
export function instanceOfUpdatePalReauthDocumentSelections200Response(value: object): value is UpdatePalReauthDocumentSelections200Response {
    return true;
}

export function UpdatePalReauthDocumentSelections200ResponseFromJSON(json: any): UpdatePalReauthDocumentSelections200Response {
    return UpdatePalReauthDocumentSelections200ResponseFromJSONTyped(json, false);
}

export function UpdatePalReauthDocumentSelections200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthDocumentSelections200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UpdatePalReauthDocumentSelections200ResponseDataFromJSON(json['data']),
    };
}

export function UpdatePalReauthDocumentSelections200ResponseToJSON(json: any): UpdatePalReauthDocumentSelections200Response {
    return UpdatePalReauthDocumentSelections200ResponseToJSONTyped(json, false);
}

export function UpdatePalReauthDocumentSelections200ResponseToJSONTyped(value?: UpdatePalReauthDocumentSelections200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UpdatePalReauthDocumentSelections200ResponseDataToJSON(value['data']),
    };
}

